import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

const defaultProps = {
  color: '#27A9E1',
};

const GiftTag = ({ color, height, width }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 420 205"
    style={{ enableBackground: 'new 0 0 420 205' }}
    xmlSpace="preserve"
    width={width}
    height={height}
  >
    <g>
      <g>
        <path
          fill="#686868"
          d="M32.1,204.8c-4.5,0-11.4-0.8-16.9-7.3c-10.7-12.5-11.7-40.7-3-83.8l1,0.2c-8.6,42.8-7.7,70.7,2.8,83
            c6.2,7.3,14.2,7,18.4,6.9l0.7,0l0,1l-0.7,0C33.7,204.7,33,204.8,32.1,204.8z"
        />
      </g>
      <g>
        <defs>
          <path
            id="SVGID_1_"
            d="M85.7,5.9L5,65.2v72.7l80.7,60.2H415L414.9,5.8L85.7,5.9z M18.1,111.2c-5.2,0-9.5-4.3-9.5-9.5
              c0-5.2,4.3-9.5,9.5-9.5s9.5,4.3,9.5,9.5C27.6,106.9,23.3,111.2,18.1,111.2z"
          />
        </defs>
        <clipPath id="SVGID_2_">
          <use
            xlinkHref="#SVGID_1_"
            style={{ overflow: 'visible' }}
          />
        </clipPath>
        <path
          fill="#F2F2F2"
          d="M84.8,3.3L2.4,63.8v75.2l82.4,61.6h332.6V3.3H84.8z M18.1,111.3c-5.2,0-9.5-4.3-9.5-9.5s4.3-9.5,
            9.5-9.5s9.5,4.3,9.5,9.5S23.4,111.3,18.1,111.3z"
        />
        <g opacity="0.3" clipPath="url(#SVGID_2_)">
          <rect x="81.2" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="68.6" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="55.9" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="43.3" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="30.6" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="17.9" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="5.3" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="169.9" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="157.2" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="144.5" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="131.9" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="119.2" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="106.6" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="93.9" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="258.5" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="245.8" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="233.2" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="220.5" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="207.8" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="195.2" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="182.5" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="347.1" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="334.5" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="321.8" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="309.1" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="296.5" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="283.8" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="271.2" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="410.4" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="397.8" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="385.1" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="372.4" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
          <rect x="359.8" y="4.5" fill="#E6E7E8" width="5" height="194.9" />
        </g>
      </g>
      <path
        fill={color}
        d="M415,5.8v192.4H85.8L5,137.8V65.1L85.7,5.8H415 M420,
          0.7H84.1L0,62.5v77.8l84.1,62.9H420v-16.7V0.7L420,0.7z"
      />
      <g>
        <path
          fill="#686868"
          d="M34.8,204.7v-1c2.6,0,4.1-2.1,4.7-6.3c2.6-21.4-22.9-87.1-26.7-88.1c0,0,0.1,0,0.2-0.1l-0.8-0.5
            c0.2-0.4,0.6-0.5,1.1-0.3c4.5,1.8,31.1,69.3,27.1,90.4C39.5,202.7,37.6,204.7,34.8,204.7z"
        />
      </g>
    </g>
  </svg>
);

GiftTag.propTypes = propTypes;

GiftTag.defaultProps = defaultProps;

export default GiftTag;
